import React, { useEffect, useState } from 'react';
import DeleteDataModel from './DeleteDataModel';
import { LIcon } from 'assests/GmsIcons';
import { TConnector, TField, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../model';
import { CALCULATED, CONNECTOR, FRACTION } from 'Pages/GMS/ISR/ISRConstants';

type TFieldItemProps = {
    id: string;
    fieldName: string;
    fieldId:string|null|undefined;
    fieldType: string;
    isSelected: boolean;
    onSelect: () => void;
    classColor?: string;
    indexInfo: TIndexState;
    showCalculatedField?: boolean;
    onDelete: (fieldName: string|null|undefined) => void;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
}

const FieldItem = ({id, fieldName,fieldId, fieldType, onDelete, isSelected, onSelect, selectedItem, userProjectDataModels, indexInfo, showCalculatedField, classColor}: TFieldItemProps) => {
    const [name, setName] = useState<string>('');

    const handleContextMenuOptionClick = () => {
        onDelete(fieldId);
    };

    useEffect(() => {
        if (selectedItem && 'belongsToDataModel' in selectedItem && selectedItem?.belongsToDataModel) {
            setName(userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]?.data.fields[indexInfo?.fieldIndex ?? -1]?.type ?? "");
        } else {
            setName(userProjectDataModels?.project.fields[indexInfo?.fieldOutsideDataModelIndex ?? -1]?.data?.type ?? "");
        }
    }, [selectedItem]);
    
    return (
        <div id={id}>
            <div 
                id={`${id}-main`}
                onClick={onSelect} 
                className={`tw-rounded tw-cursor-pointer tw-bg-shades-of-grey-0 tw-box-border tw-w-auto tw-flex tw-flex-row tw-items-center tw-justify-between tw-gap-[12px] tw-border-[1px] tw-border-solid ${isSelected ? 'tw-border-primary tw-text-primary' : 'tw-border-shades-of-grey-30 tw-text-shades-of-grey-60'}`}
            >
                <div id={`${id}-content`} className='tw-flex tw-justify-start tw-items-center'>
                    {classColor ? 
                        <div 
                            id={`${id}-color-bar`}
                            style={{backgroundColor: classColor}} 
                            className="tw-w-[5px] tw-h-[42px] tw-rounded-tl-[3px] tw-rounded-bl-[3px]" 
                        /> 
                    : null}
                    <div id={`${id}-info`} className='tw-px-3 tw-py-[3px]'>
                        <label id={`${id}-name`} className='tw-text-xs tw-block'>
                            {fieldName}
                        </label>
                        <div id={`${id}-type-container`} className='tw-flex tw-items-center tw-gap-2'>
                            <label id={`${id}-type`} className='tw-text-xs tw-text-[#747593] tw-block'>
                                {(fieldType !== "Connector") ? 'Field - ' : ''}{fieldType.replace("Connector", CONNECTOR)}
                            </label>
                            {showCalculatedField && showCalculatedField ? 
                                <div 
                                    id={`${id}-calculated-badge`}
                                    className="tw-w-[67px] tw-h-4 tw-px-1 tw-bg-orange-100 tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex"
                                >
                                    <div id={`${id}-calculated-text`} className="tw-text-yellow-700 tw-text-xs tw-font-normal">
                                        {CALCULATED}
                                    </div>
                                </div> 
                            : null}
                        </div>
                    </div>
                </div>
                <div id={`${id}-delete-menu`}>
                    <DeleteDataModel onContextMenuOptionClick={handleContextMenuOptionClick}/>
                </div>
            </div>
            
            {isSelected && name === FRACTION ? 
                <div id={`${id}-fraction-details`} className='tw-flex tw-justify-start tw-w-auto tw-ms-2'>
                    <LIcon />
                    <div id={`${id}-fraction-subfield`} className='tw-mt-2 tw-rounded tw-cursor-pointer tw-bg-[#F4F5F7] tw-box-border tw-w-full tw-flex tw-flex-row tw-items-center tw-justify-between tw-py-[3px] tw-px-3 tw-gap-[12px] tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 tw-text-shades-of-grey-60'>
                        <div id={`${id}-fraction-info`}>
                            <label id={`${id}-fraction-name`} className='tw-text-xs tw-block tw-italic tw-font-medium tw-text-shades-of-grey-40'>
                                {fieldName} decimal
                            </label>
                            <label id={`${id}-fraction-type`} className='tw-text-xs tw-italic tw-text-[#97A0AF] tw-block'>
                                Field - {fieldType}
                            </label>
                        </div>
                    </div>
                </div>
            : <div id={`${id}-empty-fraction`}></div>}
        </div>
    );
}

export default FieldItem;